import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Col, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  whiteLabelJRActive,
  whiteLabelJRStartModal,
} from "../../../qraphql/globalVar/state";
import Logo from "./images/whiteLabelSettings.png";

export default function WhiteLabelSettingsModal() {
  const whiteLabelJRStartModalValue = useReactiveVar(whiteLabelJRStartModal);
  const { t } = useTranslation();
  const handleClose = () => {
    whiteLabelJRStartModal(false);
  };

  return (
    <Modal show={whiteLabelJRStartModalValue} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fs-5">
          {t("whiteLabel.White Lable Settings")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden text-center pt-0">
        <img
          src={Logo}
          loading="lazy"
          alt="White Lable Settings"
          className="img-fluid mb-3"
        />
        <Col md={6} className="mx-auto mb-3">
          <div className="fs-7">{t("whiteLabel.startStepsInfo")}</div>
        </Col>

        <Col md={6} className="mx-auto mb-2">
          <Button
            variant="success"
            className="w-100 fw-bold"
            size="sm"
            style={{ paddingTop: 12, paddingBottom: 12 }}
            onClick={() => {
              whiteLabelJRActive(true);
              handleClose();
            }}
          >
            {t("whiteLabel.Start Connection")}
          </Button>
        </Col>
        <Button
          variant="link"
          className="fw-normal text-success mx-auto mb-1"
          size="sm"
          onClick={handleClose}
        >
          {t("whiteLabel.Skip Education")}
        </Button>
      </Modal.Body>
    </Modal>
  );
}
